(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["el-family-details"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('el-family-details')){
 customElements.define('el-family-details',class extends HTMLElement{
  connectedCallback(){
   if(this.ready)return;this.ready=true;
   this.addEventListener('click',event=>{
    const button=event.target.closest('button[data-stain]');if(!button)return;
    this.querySelector('[data-family-stain]').value=button.dataset.stain;
    this.querySelector('[data-stain-label]').textContent=button.dataset.stain;
    this.querySelector('[data-stain-image]').src=button.querySelector('img').src;
    this.querySelectorAll('[data-stain]').forEach(item=>item.setAttribute('aria-pressed',String(item===button)));
    this.querySelector('details').open=false;this.querySelector('summary').focus();
   });
   this.addEventListener('keydown',event=>{if(event.key==='Escape'){this.querySelector('details').open=false;this.querySelector('summary').focus();}});
  }
 });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["el-name-personalizer"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('el-name-preview')){
  customElements.define('el-name-preview',class extends HTMLElement{
    connectedCallback(){
      if(this.ready){this.resizeObserver.observe(this.querySelector('.el-np__canvas'));this.resizeObserver.observe(this.querySelector('[data-gallery]'));return;}
      this.ready=true;
      this.nameInput=this.querySelector('[data-name]');
      this.fontInput=this.querySelector('[data-font]');
      this.preview=this.querySelector('[data-preview]');
      this.status=this.querySelector('[data-status]');
      this.copyButton=this.querySelector('[data-copy]');
      this.loadedFonts=new Set(['Arial']);
      this.changeId=0;
      this.families={"Madina":"ELMadina","Montserrat":"ELMontserrat","Playfair Display":"ELPlayfairDisplay","Allura":"ELAllura","Hello Honey":"ELNew3","Kallinsha":"ELNew0","Anastasia":"ELUploaded8","Bromello":"ELUploaded7","Bromello Italic":"ELUploaded6","Flash Script":"ELUploaded5","Samantha Signature":"ELUploaded4","Rastalia":"ELUploaded3","Hatia Script":"ELUploaded2","Northern Petal":"ELUploaded1","Monlea":"ELUploaded0",'Arial':'Arial, sans-serif','Great Vibes':'ELGreatVibes','Arizonia':'Arizonia','Cinzel Decorative':'"Cinzel Decorative"','Italianno':'Italianno','Baloo':'Baloo','Baloo 2':'"Baloo 2"','Nunito':'Nunito','Parisienne':'Parisienne','Poppins':'Poppins'};
      this.buildGallery();
      const toggle=this.querySelector('[data-show-fonts]');
      const featured=new Set(['Arial','Great Vibes','Arizonia','Cinzel Decorative','Allura','Madina']);
      const showFonts=()=>{const expanded=toggle.getAttribute('aria-expanded')==='true';this.cards.forEach(({card,font})=>{card.hidden=!expanded&&!featured.has(font)&&font!==this.fontInput.value;});this.fit();};
      toggle.addEventListener('click',()=>{const expanded=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(expanded));toggle.textContent=expanded?toggle.dataset.less:toggle.dataset.more;showFonts();});
      showFonts();
      const form=this.closest('form');
      if(form){
        this.validateForm=event=>{
          this.nameInput.setCustomValidity(this.nameInput.value.trim()?'':this.dataset.required);
          const year=this.querySelector('[data-est]');
          if(year)year.setCustomValidity(!year.value||/^[0-9]{4}$/.test(year.value)?'':this.dataset.invalidYear);
          const invalid=[this.nameInput,year].filter(Boolean).find(input=>!input.checkValidity());
          if(invalid){event.preventDefault();event.stopImmediatePropagation();invalid.focus();invalid.reportValidity();}
        };
        form.addEventListener('submit',this.validateForm,true);
        this.addEventListener('input',event=>{if(event.target.setCustomValidity)event.target.setCustomValidity('');});
      }
      this.nameInput.addEventListener('input',()=>{if(!this.copyButton.disabled)this.status.textContent='';this.update();});
      this.fontInput.addEventListener('change',()=>this.changeFont());
      this.copyButton.addEventListener('click',()=>this.copy());
      this.resizeObserver=new ResizeObserver(()=>this.fit());
      this.resizeObserver.observe(this.querySelector('.el-np__canvas'));
      this.resizeObserver.observe(this.querySelector('[data-gallery]'));
      this.update();
    }
    disconnectedCallback(){this.resizeObserver?.disconnect();}
    buildGallery(){
      const gallery=this.querySelector('[data-gallery]');
      this.cards=Array.from(this.fontInput.options,(option,index)=>{
        const card=document.createElement('button');card.type='button';card.className='el-np__card';card.setAttribute('aria-pressed','false');
        const sample=document.createElement('span');sample.className='el-np__sample';sample.dir='auto';sample.style.fontFamily=this.families[option.value];
        const caption=document.createElement('span');caption.className='el-np__caption';caption.textContent=String(index+1).padStart(2,'0')+' · '+option.textContent;
        const status=document.createElement('span');status.className='el-np__load';
        card.append(sample,caption,status);gallery.append(card);
        card.addEventListener('click',()=>{this.fontInput.value=option.value;this.changeFont();});
        const entry={card,sample,status,font:option.value};
        if(option.value!=='Arial'){
          card.disabled=true;sample.style.visibility='hidden';status.textContent=this.dataset.loading;
          let timer;
          Promise.race([document.fonts.load('40px '+this.families[option.value]),new Promise((resolve,reject)=>{timer=setTimeout(()=>reject(new Error('Font timeout')),12000);})])
          .then(fonts=>{if(!fonts.length)throw new Error('Unavailable');this.loadedFonts.add(option.value);sample.style.visibility='visible';card.disabled=false;status.textContent='';this.fit();})
          .catch(()=>{status.textContent=gallery.dataset.unavailable;card.disabled=true;})
          .finally(()=>clearTimeout(timer));
        }
        return entry;
      });
    }
    update(){
      this.preview.textContent=this.nameInput.value||this.dataset.empty;
      this.cards.forEach(({card,sample,font})=>{sample.textContent=this.preview.textContent;card.setAttribute('aria-pressed',String(font===this.fontInput.value));});
      this.querySelector('[data-count]').textContent=this.nameInput.value.length;
      this.querySelector('[data-name-label]').textContent=this.nameInput.value;
      this.querySelector('[data-font-label]').textContent=this.fontInput.value;
      const orderFont=this.querySelector('[data-font-order]');
      if(orderFont)orderFont.value=this.fontInput.value;
      this.preview.style.fontFamily=this.families[this.fontInput.value]||this.families.Arial;
      this.fit();
    }
    fit(){
      const ruler=document.createElement('canvas').getContext('2d');
      if(ruler)this.cards?.forEach(({sample,font})=>{ruler.font='60px '+this.families[font];const width=sample.clientWidth;if(width)sample.style.fontSize=Math.max(14,Math.min(60,60*(width-16)/Math.max(1,ruler.measureText(sample.textContent).width)))+'px';});
      const canvas=this.querySelector('.el-np__canvas');
      if(!canvas.clientWidth)return;
      const width=canvas.clientWidth-34;
      const measure=document.createElement('canvas').getContext('2d');
      if(!measure)return;
      measure.font='60px '+this.families[this.fontInput.value];
      const textWidth=measure.measureText(this.preview.textContent).width;
      this.preview.style.fontSize=Math.max(22,Math.min(60,60*width/Math.max(1,textWidth)*.9))+'px';
    }
    async changeFont(){
      const change=++this.changeId;
      const selected=this.fontInput.value;
      this.status.textContent='';
      this.copyButton.disabled=false;
      this.preview.style.visibility='visible';
      if(!this.loadedFonts.has(selected)){
        this.preview.style.visibility='hidden';
        this.copyButton.disabled=true;
        this.status.textContent=this.dataset.loading;
        let timer;
        try{
          const fonts=await Promise.race([
            document.fonts.load('40px '+this.families[selected]),
            new Promise((resolve,reject)=>{timer=setTimeout(()=>reject(new Error('Font timeout')),12000);})
          ]);
          if(!fonts.length)throw new Error('Font unavailable');
          this.loadedFonts.add(selected);
          if(change!==this.changeId)return;
          this.status.textContent='';
        }catch{
          if(change!==this.changeId)return;
          this.fontInput.value='Arial';
          this.status.textContent=this.dataset.fontError;
        }finally{clearTimeout(timer);}
      }
      if(change!==this.changeId)return;
      this.copyButton.disabled=false;
      this.preview.style.visibility='visible';this.update();
    }
    async copy(){
      if(this.copyButton.disabled)return;
      const name=this.nameInput.value.trim();
      if(!name){this.status.textContent=this.dataset.required;this.nameInput.focus();return;}
      const selection=name+' — '+this.fontInput.value;
      try{await navigator.clipboard.writeText(selection);this.status.textContent=this.dataset.copied;}
      catch{this.status.textContent=this.dataset.copyError;}
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["el-outdoor-coating"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('el-outdoor-coating')) {
    customElements.define('el-outdoor-coating', class extends HTMLElement {
      connectedCallback() {
        this.picker = this.closest('variant-selects');
        this.select = this.querySelector('select');
        this.button = this.querySelector('button');
        if (!this.picker || this.select.options.length !== 2) return;
        this.position = Number(this.dataset.position);
        this.baseValue = this.select.options[0].value;
        this.addedValue = this.select.options[1].value;
        this.variants = JSON.parse(this.picker.querySelector('script[type="application/json"]').textContent);
        this.onChange = () => queueMicrotask(() => this.sync());
        this.onClick = () => {
          this.select.value = this.select.value === this.addedValue ? this.baseValue : this.addedValue;
          this.select.dispatchEvent(new Event('change', { bubbles: true }));
          this.sync();
        };
        this.picker.addEventListener('change', this.onChange);
        this.button.addEventListener('click', this.onClick);
        this.querySelector('[data-coating-fallback]').hidden = true;
        this.button.hidden = false;
        this.sync();
      }
      disconnectedCallback() {
        this.picker?.removeEventListener('change', this.onChange);
        this.button?.removeEventListener('click', this.onClick);
      }
      sync() {
        const values = Array.from(this.picker.querySelectorAll('.product-form__input'), input => {
          const select = input.querySelector('.select__select');
          return select ? select.value : input.querySelector('input[type="radio"]:checked')?.value;
        });
        const match = value => this.variants.find(variant => variant.options.every((option, index) => option === (index === this.position ? value : values[index])));
        const base = match(this.baseValue);
        const coated = match(this.addedValue);
        const selected = this.select.value === this.addedValue;
        const available = Boolean(base && coated && coated.available);
        this.button.disabled = !selected && !available;
        this.button.setAttribute('aria-pressed', String(selected));
        this.querySelector('.el-coating-button__icon').textContent = selected ? '✓' : '+';
        this.querySelector('[data-coating-label]').textContent = selected ? this.dataset.addedLabel : this.dataset.addLabel;
        const price = base && coated ? new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: this.dataset.currency, currencyDisplay: 'code' }).format((coated.price - base.price) / 100) : '';
        this.querySelector('[data-coating-detail]').textContent = selected
          ? `+${price} ${this.dataset.perSign} · ${this.dataset.removeLabel}`
          : available ? `+${price} ${this.dataset.perSign}` : this.dataset.unavailableLabel;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["el-stain-picker"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('el-stain-picker')) {
  customElements.define('el-stain-picker', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.select = this.querySelector('select');
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.buttons = [...this.querySelectorAll('[data-value]')];
      if (!this.select || !this.buttons.length) return;
      this.abort = new AbortController();
      const settings = {signal: this.abort.signal};
      this.buttons.forEach(button => button.addEventListener('click', () => {
        this.select.value = button.dataset.value;
        this.update();
        this.details.open = false;
        this.summary.focus();
        this.select.dispatchEvent(new Event('change', {bubbles: true}));
      }, settings));
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') {this.details.open = false; this.summary.focus();}
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          this.details.open = true;
          const enabled = this.buttons.filter(button => !button.disabled);
          const index = enabled.indexOf(document.activeElement);
          enabled[(index + (event.key === 'ArrowDown' ? 1 : -1) + enabled.length) % enabled.length]?.focus();
        }
      }, settings);
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.details.open = false;
      }, settings);
      this.select.closest('variant-selects')?.addEventListener('change', () => {
        this.update();
        requestAnimationFrame(() => this.update());
      }, settings);
      this.observer = new MutationObserver(() => this.update());
      this.observer.observe(this.select, {subtree:true,childList:true,attributes:true});
      this.update();
      this.details.hidden = false;
      this.dataset.ready = 'true';
      // The original first variant may use a retired finish. Let the theme update
      // its variant ID and price from the visible selector once it is initialized.
      const initialize = () => customElements.whenDefined('variant-selects').then(() => {
        if (this.isConnected && this.dataset.sync === 'true') {
          this.dataset.sync = '';
          this.select.dispatchEvent(new Event('change', {bubbles:true}));
        }
      });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true,signal:this.abort.signal});
      else initialize();
    }
    update() {
      const selected = this.buttons.find(button => button.dataset.value === this.select.value);
      if (selected) {
        this.querySelector('[data-selected-image]').src = selected.querySelector('img').src;
        this.querySelector('[data-selected-name]').textContent = selected.querySelector('span').textContent;
      }
      this.buttons.forEach(button => {
        const option = [...this.select.options].find(item => item.value === button.dataset.value);
        button.setAttribute('aria-pressed', String(button === selected));
        button.disabled = !option || option.disabled || option.classList.contains('non-existent');
      });
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      delete this.dataset.ready;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
